/**
 * Real repeats (2026-10-12): the next copy of a repeating task waits until `available_from`
 * before the family sees it (server: supabase/functions/_shared/repeat.ts). Grown-ups still see
 * it in Admin with "comes back on …".
 */
export function isAvailableNow(task: { available_from?: string | Date | null; is_waiting?: boolean | null }, now: Date = new Date()): boolean {
  // A chain step waits until the step before it is approved (2026-10-13).
  if (task.is_waiting) return false;
  if (!task.available_from) return true;
  const t = new Date(task.available_from as any).getTime();
  return !Number.isFinite(t) || t <= now.getTime();
}
